import { getExamsHistoryThunk } from '../../../store/workspace/thunks';
import { selectProfileData } from '../../../store/workspace/selectors';
import { useDispatch, useSelector } from '../../../store/store';
import { setJobBoxTab } from '../../../store/workspace/slice';
import { selectUserId } from '../../../store/auth/selectors';
import JobApplications from './containers/JobApplications';
import { useJobStages } from './hooks/useJobStages';
import WelcomeBox from './components/WelcomeBox';
import { dashboardStages } from './constants';
import InfoCard from './components/InfoCard';
import styles from './style.module.scss';
import JobBox from './containers/JobBox';
import { useEffect } from 'react';

/**
 * The applicant's home screen: how many jobs sit in each stage of the funnel,
 * the jobs waiting in the selected stage, and the applications already sent.
 */
function Dashboard() {
    const dispatch = useDispatch();
    const stages = useJobStages();
    const userId = useSelector(selectUserId);
    const profile = useSelector(selectProfileData);

    useEffect(() => {
        if (!userId) return;
        dispatch(getExamsHistoryThunk(userId));
    }, [userId]);

    return (
        <div className={styles.container}>
            <div className={styles.main}>
                <div className={styles.summary}>
                    {dashboardStages.map(({ id, cardTitle, icon: Icon }) => <InfoCard
                        key={id}
                        title={cardTitle}
                        icon={<Icon />}
                        value={stages[id].length}
                        onClick={() => dispatch(setJobBoxTab(id))}
                    />)}
                </div>

                {profile?.matchedJobs
                    ? <JobBox matchingDisabled={!profile.setting?.seeking} />
                    : <WelcomeBox />}
            </div>

            <JobApplications />
        </div>
    );
};

export default Dashboard;
